import React, {InputHTMLAttributes} from 'react'
import {FieldValues, FieldErrors} from 'react-hook-form'
import {ErrorMessage} from '@hookform/error-message'

interface Props
 extends InputHTMLAttributes<HTMLInputElement> {
 label?: string
 type: string
 id?: string
 name: string
 className?: string
 wrapperClassName?: string
 inputWrapperClassName?: string
 labelClassName?: string
 errorIconClassName?: string
 iconPath?: string
 showIcon?: boolean
 helperTextClass?: string
 helperText?: string
 register?: FieldValues
 errors?: FieldErrors | undefined
}

const CheckboxField = ({
 label,
 className,
 wrapperClassName,
 name,
 type = 'checkbox',
 required,
 defaultChecked = false,
 checked,
 id,
 onChange,
 onBlur,
 disabled,
 value,
 register,
 errors,
 labelClassName,
}: Props) => {
 const isControlled = checked !== undefined
 return (
  <div className={`${wrapperClassName}`}>
   {label && (
    <label
     htmlFor={id}
     className={`input-label ${labelClassName}`}
    >
     {label}
     {required && <span className='required-field'>*</span>}
    </label>
   )}
   <input
    type={type}
    name={name}
    id={id ?? name}
    className={`w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 ${className} ${
     required && errors?.[name]
      ? 'border-error-90'
      : 'border-neutral-30'
    }`}
    {...(isControlled ? {checked} : {defaultChecked})}
    onChange={onChange}
    onBlur={onBlur}
    disabled={disabled}
    value={value}
    {...register}
   />
   {errors && (
    <ErrorMessage
     errors={errors}
     name={name}
     render={({message}) => (
      <p className='error-msg error-cls'>{message}</p>
     )}
    />
   )}
  </div>
 )
}

export {CheckboxField}
